import React, { useState, useEffect, useRef } from "react";
import logoSrc from '../img/logo.png';
import './Contracting.css';
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method
const PrivacyPolicy = () => {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  const [activeSection, setActiveSection] = useState("introduction");
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const sections = [
    { 
      id: "introduction", 
      label: "Privacy Policy Introduction", 
      content: (
        <div className="section">
          <h3>Privacy Policy Introduction</h3>
          <p>Shigjeta LLC (“we,” “our,” “us”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, share, and protect your personal data when you use our website (shigjeta.com), subdomains, email communications, pages, chats, links, or any associated content. By accessing or using our services, you agree to the terms outlined in this Privacy Policy.</p>
        </div>
      )
    },
    { 
      id: "dataCollection", 
      label: "Types of Data Collected", 
      content: (
        <div className="section">
          <h3>Types of Data Collected</h3>
          <p>We collect various types of personal data, including but not limited to:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Payment information</li>
            <li>IP address</li>
            <li>Any other information you provide to us</li>
          </ul>
        </div>
      ) 
    },
    { 
      id: "methodsOfCollection", 
      label: "Methods of Data Collection", 
      content: (
        <div className="section">
          <h3>Methods of Data Collection</h3>
          <p>We collect personal data through:</p>
          <ul>
            <li>Website forms</li>
            <li>Cookies and tracking technologies</li>
            <li>Third-party services</li>
          </ul>
        </div>
      )
    },
    { 
      id: "purposeOfCollection", 
      label: "Purpose of Data Collection", 
      content: (
        <div className="section">
          <h3>Purpose of Data Collection</h3>
          <p>We use personal data for the following purposes:</p>
          <ul>
            <li>Service delivery</li>
            <li>Marketing and communication</li>
            <li>Customer support</li>
            <li>Legal compliance</li>
          </ul>
        </div>
      )
    },
    { 
      id: "dataSharing", 
      label: "Data Sharing", 
      content: (
        <div className="section">
          <h3>Data Sharing</h3>
          <p>We may share your personal data with:</p>
          <ul>
            <li>Service providers for operational purposes</li>
            <li>Business partners for joint ventures and promotions</li>
            <li>Legal authorities if required by law</li>
          </ul>
        </div>
      )
    },
    { 
      id: "userRights", 
      label: "User Rights", 
      content: (
        <div className="section">
          <h3>User Rights</h3>
          <p>You have the following rights regarding your personal data:</p>
          <ul>
            <li>Access: You can request a copy of your personal data held by us.</li>
            <li>Rectification: You can request to correct any inaccurate or incomplete data.</li>
            <li>Deletion: You can request the deletion of your personal data.</li>
            <li>Data Portability: You can request to transfer your personal data to another service provider.</li>
          </ul>
          <p>To exercise these rights, please contact us at <a href="mailto:privacy@shigjeta.com">privacy@shigjeta.com</a>.</p>
        </div>
      )
    },
    { 
      id: "dataSecurity", 
      label: "Data Security", 
      content: (
        <div className="section">
          <h3>Data Security</h3>
          <p>We implement various security measures to protect your personal data, including:</p>
          <ul>
            <li>Encryption</li>
            <li>Access controls</li>
            <li>Regular security assessments</li>
          </ul>
          <p>However, please note that we operate an open development environment and hosted service. Despite our efforts to secure your data, we cannot guarantee absolute security. Use our services at your own risk.</p>
        </div>
      )
    },
    { 
      id: "dataRetention", 
      label: "Data Retention", 
      content: (
        <div className="section">
          <h3>Data Retention</h3>
          <p>We retain personal data for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.</p>
        </div>
      )
    },
    { 
      id: "internationalTransfers", 
      label: "International Data Transfers", 
      content: (
        <div className="section">
          <h3>International Data Transfers</h3>
          <p>We may transfer personal data to countries outside of Kosovo with appropriate safeguards in place to ensure the protection of your data.</p>
        </div>
      )
    },
    { 
      id: "cookies", 
      label: "Cookies and Tracking Technologies", 
      content: (
        <div className="section">
          <h3>Cookies and Tracking Technologies</h3>
          <p>We use cookies and other tracking technologies to:</p>
          <ul>
            <li>Enhance your user experience</li>
            <li>Analyze website traffic</li>
          </ul>
          <p>You can manage your cookie preferences through your browser settings.</p>
        </div>
      )
    },
    { 
      id: "childrensPrivacy", 
      label: "Children’s Privacy", 
      content: (
        <div className="section">
          <h3>Children’s Privacy</h3>
          <p>We do not knowingly collect personal data from children under the age of 13. If we become aware that we have collected such data, we will take steps to delete it.</p>
        </div>
      )
    },
    { 
      id: "policyUpdates", 
      label: "Policy Updates", 
      content: (
        <div className="section">
          <h3>Policy Updates</h3>
          <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website. It is your responsibility to review this Privacy Policy periodically for any updates or changes.</p>
        </div>
      )
    },
    { 
      id: "contact", 
      label: "Contact Information", 
      content: (
        <div className="section">
          <h3>Contact Information</h3>
          <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
          <p>Shigjeta LLC</p>
          <p>Ismail Raka BLVD</p>
          <p>Kacanik, Kosovo</p>
          <p>Email: <a href="mailto:privacy@shigjeta.com">privacy@shigjeta.com</a></p>
        </div>
      )
    },
    { 
      id: "conclusion", 
      label: "Conclusion", 
      content: (
        <div className="section">
          <h3>Conclusion</h3>
          <p>While Shigjeta LLC takes extensive measures to protect your data, we operate in an open development environment and offer hosted services. This inherently carries risks of accidental data leaks. Therefore, we advise you to take precautions when using our services and be mindful of the potential risks. By using our services, you acknowledge and accept these risks.</p>
        </div>
      )
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY + window.innerHeight / 2;
      const footer = document.getElementById("footerElements");
      const footerPosition = footer ? footer.offsetTop : 0;
      if (currentScroll + window.innerHeight >= footerPosition) {
        setIsFooterVisible(true);
      } else {
        setIsFooterVisible(false);
      }
      const sectionOffsets = sections.map((section) => {
        const element = document.getElementById(section.id);
        return {
          id: section.id,
          offsetTop: element.offsetTop,
          offsetBottom: element.offsetTop + element.offsetHeight,
        };
      });
      const active = sectionOffsets.find((section) => currentScroll >= section.offsetTop && currentScroll <= section.offsetBottom);
      if (active && active.id !== activeSection) {
        setActiveSection(active.id);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [sections, activeSection]);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  return (
    <>
    
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
          <h1 className="banner-title" id="titulli">your privacy, our priority</h1>
            <p className="banner-description">
              The finest for a global impact—tailored solutions that drive success.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>


          </div>
          {/* Background Image */}
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Contracting Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>
      <div className="App">
        <nav className={`circle-nav ${isFooterVisible ? "stop" : ""}`}>
          <button className="circle-dropdown" onClick={toggleDropdown}>
            {isDropdownVisible ? "Close Menu" : "Privacy Menu"}
          </button>
          
          {isDropdownVisible && (
            <div className="dropdown-content">
            {sections.map((section) => (
  <div
    key={section.id}
    className={`dropdown-item ${activeSection === section.id ? "active" : ""}`}
    onClick={() => {
      // Scroll to the section
      const element = document.getElementById(section.id);
      const offset = 70;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });

      // Close the dropdown after selecting a section
      setIsDropdownVisible(false);
    }}
  >
    {section.label}
  </div>
))}
            </div>
          )}
        </nav>
        <main className="sections">
          {sections.map((section) => (
            <section key={section.id} id={section.id} className="section">
              <h1>{section.label}</h1>
              <div>{section.content}</div>
            </section>
          ))}
        </main>
      </div>
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default PrivacyPolicy;
